export default __webpack_public_path__ + "static/media/veterinarian.5bdf7a48.png";